module.exports = __webpack_public_path__ + "media/images/athletes/992-4905bba9808363ef53d28e66f5e7c283.png";